import { toast } from "react-toastify";
import { createSlice } from '@reduxjs/toolkit';
import {CommonService} from '../../services/CommonService';

import { APIResponse } from '../types/Common';


const common = createSlice({
    name: 'common',
    initialState: {
        common: {},
        partner: []
    },
    reducers: {
        config: (state, action) => {
            state.common = action.payload;
        },

        partner: (state, action) => {
            state.partner = action.payload;
        },
    },
});

export default common.reducer;

const { config, partner } = common.actions


export const getMasterConfig = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getMasterConfig().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(config(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const getPartnerList = () => async (dispatch: any) => {
    return new Promise((resolve, reject) => {
        CommonService.getPartnerList().then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                let data = response.data && response.data.data
                resolve(response.data)
                dispatch(partner(data))
            }
            else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
            (error: Error) => {
                reject(error);
            })
    })
}

export const addDocument = (params: object) => {
    return new Promise((resolve, reject) => {
        CommonService.addDocument(params).then((response: APIResponse) => {
            if ((response && response.data && response.data.status) === 200) {
                resolve(response.data)

            } else {
                let errorMsg = (response && response.data && response.data.message) || ''
                if (errorMsg) toast.error(response.data.message);
                resolve(response && response.data)
            }
        },
        (error: Error) => {
            reject(error);
        })
    })
}



